import type { IconData } from '@stacksjs/iconify-core'

export const lightbulbSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5C13.783 1.5 5.5 9.783 5.5 20c0 5.885 2.75 11.129 7.028 14.515c.186.663.367 1.273.526 1.788c.47 1.534 1.775 2.709 3.452 2.884c1.453.151 3.855.313 7.494.313s6.041-.162 7.494-.313c1.677-.175 2.981-1.35 3.452-2.884c.159-.515.34-1.125.526-1.788C39.75 31.128 42.5 25.885 42.5 20C42.5 9.783 34.217 1.5 24 1.5m0 9a8.5 8.5 0 0 1 8.5 8.5a1.5 1.5 0 0 0 3 0c0-6.351-5.149-11.5-11.5-11.5a1.5 1.5 0 0 0 0 3m-7.754 31.173a7 7 0 0 1-.798-.133q.081.453.157.85c.345 1.843 1.706 3.485 3.773 3.798c1.123.17 2.652.312 4.622.312c1.873 0 3.422-.129 4.612-.285c2.376-.312 3.928-2.275 4.163-4.44l.032-.3q-.508.14-1.054.198C30.201 41.835 27.712 42 24 42s-6.202-.165-7.754-.327\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default lightbulbSolid
